import { useApolloClient } from '@apollo/client';
import { Box } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Loading from '../../../components/loading/Loading';
import {
    BROADBAND_TECHNOLOGY,
    SERVICE_GROUPS,
} from '../../../components/myeirconstant/myEirConstant';
import { handleAction } from '../../../sharedcomponents/sweepr-action-cta/actionHandlers';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';
import getStrapiData from '../integration/strapi.client';
import HelpCentreBannerContainer from './help-centre-banner/HelpCentreBannerContainer';
import HelpCentreServicesContainer from './help-centre-services/HelpCentreServicesContainer';
import InfoTileContainer from './info-tile/InfoTileContainer';
import NoticeTileContainer from './notice-tile/NoticeTileContainer';
import styles from './style';
import SweeprContainer from './sweepr-widget/SweeprContainer';
import TroubleshootingTileContainer from './troubleshooting-tile/TroubleshootingTileContainer';

const { DUALPLAY, DUALPLAY_PSTN, SA_PSTN } = SERVICE_GROUPS;
const { NBI } = BROADBAND_TECHNOLOGY;

const HelpAndSupportContainer = () => {
    const classes = styles();
    const graphql = useApolloClient();
    const [cmsData, setCmsData] = useState();
    const [loading, setLoading] = useState(true);
    const [openError, setOpenError] = useState(false);
    const [showTroubleshoot, setShowTroubleshoot] = useState(false);
    const [sweeprParams, setSweeprParams] = useState({
        OTC: null,
    });
    const [enableSweepr, setEnableSweepr] = useState(false);
    const subscriptions = JSON.parse(
        sessionStorage.getItem('LoggedinUserSubscriptionIDandAccountID')
    );

    const getStrapiDataContents = async () => {
        const data = await getStrapiData('myeir-sweepr');
        setCmsData(data);
        return data;
    };

    const toggleError = () => {
        setOpenError(!openError);
    };
    /**
     * @function handleActionWrapper
     * @description Handles function triggered on cta click
     * @param {string} action - Action type to perform
     * @param {URL} redirectUrl - URL provided in strapi
     */
    const handleActionWrapper = (action, redirectUrl) => {
        handleAction(action, redirectUrl, graphql, setSweeprParams, toggleError);
    };

    useEffect(() => {
        document.title = 'eir app: Help & Support Centre';
        getStrapiDataContents();
    }, []);

    useEffect(() => {
        if (sweeprParams?.OTC) {
            setEnableSweepr(true);
        } else {
            setEnableSweepr(false);
        }
    }, [sweeprParams?.OTC]);

    useEffect(() => {
        if (cmsData) {
            setLoading(false);
        } else {
            setLoading(true);
        }
    }, [cmsData]);

    useEffect(() => {
        if (subscriptions) {
            const dualplaySubs = subscriptions?.filter(
                subs =>
                    subs?.serviceGroup === DUALPLAY ||
                    subs?.serviceGroup === DUALPLAY_PSTN ||
                    subs?.serviceGroup === SA_PSTN
            );
            if (dualplaySubs?.length > 0) {
                const hasNBI = dualplaySubs?.every(subs => subs?.catalogOfferCode?.includes(NBI));
                setShowTroubleshoot(!hasNBI);
            } else {
                setShowTroubleshoot(false);
            }
        }
    }, []);

    return (
        <>
            {loading && (
                <span className='loadingPosition'>
                    <Loading />
                </span>
            )}
            {!loading && (
                <Box className={classes.helpWrapper} id='help-heading' tabIndex={-1}>
                    <HelpCentreBannerContainer
                        cmsData={cmsData?.data?.attributes?.HelpCenter_Banner}
                        handleAction={handleActionWrapper}
                    />
                    <HelpCentreServicesContainer />
                    {showTroubleshoot && (
                        <TroubleshootingTileContainer
                            cmsData={cmsData?.data?.attributes?.Troubleshooting_Tile}
                            handleAction={handleActionWrapper}
                        />
                    )}
                    <InfoTileContainer
                        cmsData={cmsData?.data?.attributes?.Info_Tile}
                        handleAction={handleActionWrapper}
                    />
                    <NoticeTileContainer cmsData={cmsData?.data?.attributes?.Notice_Tile} />
                    {openError ? <MyEirErrorHandle open={openError} setOpen={toggleError} /> : ''}

                    {enableSweepr && <SweeprContainer OTC={sweeprParams?.OTC} />}
                </Box>
            )}
        </>
    );
};
export default HelpAndSupportContainer;
